import Style from "../Style.module.css"
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import * as GroupGameService from "../../api/GroupGameService";
import {Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import cabinetStyle from "./MentorCabinet.module.css";
import AvailableStylesSelector from "../AvailableStylesSelector";
import PlayersListSetup from "./PlayersListSetup";
import moment from "moment";
import {useTranslation} from "react-i18next";

function SetupGroupGamesPage(props) {
    const prices = {
        0: 0,
        2: 5,
        3: 7,
        4: 9,
        5: 10,
        6: 11
    }

    const [gameName, setGamerName] = useState("")
    const [trialGame, setTrialGame] = useState(false)
    const [saveDisabled, setSaveDisabled] = useState(true)
    const [gameNameValid, setGameNameValid] = useState(false)
    const [selectedStyle, setSelectedStyle] = useState(0)
    const [selectedDeck, setSelectedDeck] = useState()
    const [playersReady, setPlayersReady] = useState(false)
    const [players, setPlayers] = useState([])
    const [gamePrice, setGamePrice] = useState(0)
    const [withVideo, setWithVideo] = useState(true)
    const { t } = useTranslation('translation', { keyPrefix: 'groupGameSetupPage' });

    const inTrial = moment().isBefore(moment(props.freeTier))

    const nav = useNavigate()

    function ResolveTrialGame() {
        setTrialGame(!trialGame)
    }

    function ResolveWithVideo() {
        setWithVideo(!withVideo)
    }

    function ResolveGameFieldStyle(event) {
        setSelectedStyle(event.target.value)
    }

    function ResolveSelectedDeck(event) {
        setSelectedDeck(event.target.value)
    }

    function ResolveDefaultDeck(deck) {
        setSelectedDeck(deck)
    }

    function ResolveGameName(event) {
        const i = event.target.value
        setGamerName(i)
        if (!i.trim()) {
            setGameNameValid(false)
            setSaveDisabled(true)
        } else {
            setGameNameValid(true)
        }

        if (i !== "" && playersReady) {
            setSaveDisabled(false)
        }
    }

    useEffect(() => {
        let price = resolvePrice()
        setGamePrice(price)
        if (gameName !== "" && playersReady && props.currentBalance >= price) {
            setSaveDisabled(false)
        } else {
            setSaveDisabled(true)
        }
    }, [players.length, playersReady, gameName])

    function prepPlayer() {
        return players.map(player => {
            return {
                name: player.playerName,
                is_auto_dice: player.isAutoDice,
                chip_char: player.chipName,
                chip_color: player.color
            }
        })
    }

    function saveNewGroupGame() {
        setSaveDisabled(true)
        GroupGameService.postCreateGroupGame(
            gameName,
            trialGame,
            withVideo,
            selectedStyle,
            prepPlayer(),
            gamePrice * 100,
            selectedDeck.split("-")[0],
            selectedDeck.split("-")[1],
            () => {
                props.setSelectedGameType("groupGames")
                props.callBack()
            },
            () => nav("/mentor/cabinet")
        )
    }


    const renderTrialGameTooltip = (props) => (
        <Tooltip className={"trialGameTooltip"} id="trial-game-tooltip" {...props}>
            <p>{t('trialGameTooltip1')}</p>
            <div>{t('trialGameTooltip2')}</div>
            <p>{t('trialGameTooltip3')}</p>
        </Tooltip>
    )

    function resolvePrice() {
        if (!withVideo && !inTrial) {
            return 1 + 0.5 *players.length
        }
        return inTrial ? 0 : prices[players.length]
    }

    return (
        <div>
            <div>
                <div className={`${cabinetStyle.commonTile} ${cabinetStyle.profilePage}`}>
                    <Form>
                        <Form.Group className={cabinetStyle.profileElement}>
                            <Form.Label className={Style.bodyBaseText}>{t('gameName')}</Form.Label>
                            <Form.Control
                                id={"game_name_id"}
                                style={gameNameValid ? {
                                    marginBottom: "24px",
                                } : {
                                    marginBottom: "24px", border: "0.5px solid red",
                                }}
                                as="input"
                                onChange={e => ResolveGameName(e)}
                            />
                            <Form.Label className={Style.bodyBaseText}>{t('trialGame')}</Form.Label>
                            <Form>
                                <OverlayTrigger placement="top-start" delay={{show: 150, hide: 250}}
                                                overlay={renderTrialGameTooltip}>
                                    <Form.Check
                                        style={{
                                            marginBottom: "24px",
                                        }}
                                        checked={trialGame}
                                        id={"trial_game"}
                                        type="switch"
                                        onChange={e => ResolveTrialGame()}
                                    />
                                </OverlayTrigger>
                            </Form>
                            <Form.Label className={Style.bodyBaseText}>{t('video')}</Form.Label>
                                <Form>
                                    <Form.Check
                                        style={{
                                            marginBottom: "24px",
                                        }}
                                        checked={withVideo}
                                        id={"trial_game"}
                                        type="switch"
                                        onChange={e => ResolveWithVideo()}
                                    />
                                </Form>
                            <AvailableStylesSelector selectedStyle={selectedStyle}
                                                     selectedDeck={selectedDeck}
                                                     setSelectedStyle={ResolveGameFieldStyle}
                                                     setDefaultDeck={ResolveDefaultDeck}
                                                     setSelectedDeck={ResolveSelectedDeck}/>

                            <br/>
                        </Form.Group>
                    </Form>
                    <PlayersListSetup setPlayersReady={setPlayersReady} setPlayers={setPlayers}></PlayersListSetup>
                    <div style={{
                        display: "flex", justifyContent: "space-around",
                        alignContent: "center",
                        flexDirection: "column",
                        gap: "24px"
                    }}>
                        <button className={`${cabinetStyle.confirmCreateNewGame} ${cabinetStyle.sideBarText}`}
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    justifyContent: "center",
                                    gap: "6"
                                }}
                                id={"saveButton"}
                                onClick={saveNewGroupGame}
                                disabled={saveDisabled}>
                            <div>{t('createButton')}</div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end"
                                }}
                            >{resolvePrice()}
                                <div className={cabinetStyle.coinSmall}/>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SetupGroupGamesPage